<template>
	<div>
		<input
			hidden
			type="file"
			accept=".xls, .xlsx, .xlsm"
			ref="loadFile"
			@change="loadEmployeesFile"
		/>
		<app-table
			class="mt-3 no-main-list"
			:columns="columns"
			:filter-columns="false"
			:main-list="true"
			:rows="rows"
			:items-quantity="totalItemsVisible"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			:last-page="lastPage"
			:check-all="checkAll"
			:disabled-assign="disabledAssign"
			selectable
			title="EMPLEADOS"
			icon-employee
			icon-excel
			download-employees
			name="employees"
			@open-modal="$emit('open-modal', $event)"
			@on-page="$emit('on-page', $event)"
			@open-area="$emit('open-area', $event)"
			@row-is-selected="rowIsSelected"
			@on-selected-all="selectedAll"
			@on-search-event="$emit('on-search-event', $event)"
			@changeSort="$emit('changeSort', $event)"
			@changeColor="changeColor"
		>
			<template slot="excelEmployees">
				<app-tooltip-button
					:img="`${$imageUrl}/excel.svg`"
					text="Descargar Nómina"
					@click-icon="downloadEmployees({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })"
				/>
			</template>
			<template slot="excel">
				<app-tooltip-button
					:img="`${$imageUrl}/import-employee.svg`"
					text="Importar Empleados"
					@click-icon="loadExcel"
				/>
			</template>
				<template slot="loadExcel">
				<app-tooltip-button
					img="/static/pdf.png"
					text="Descargar Formato"
					@click-icon="loadFormat"
				/>
			</template>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.lastName }}
				</td>
				<td v-show="showRow(columns, 3)">{{ setGender(props.row.gender) }}</td>
				<td v-show="showRow(columns, 4)">{{ props.row.years }}</td>
				<td v-show="showRow(columns, 5)">{{ props.row.documentNumber }}</td>
				<td v-show="showRow(columns, 6)">{{ props.row.email }}</td>
				<td v-show="showRow(columns, 7)">{{ props.row.group ? props.row.group.name : null}}</td>
				<td v-show="showRow(columns, 8)">{{ props.row.points }}</td>
				<td v-show="showRow(columns, 9)" @click.stop="stopClick">
					<v-layout wrap align-center justify-start pl-2>
						<v-tooltip top>
							<v-switch
								class="switch-table ma-0 pt-2"
								style="width: 35px;"
								color="success"
								slot="activator"
								v-model="props.row.status"
								:true-value="1"
								:false-value="0"
								hide-details
								@change="$emit('click-icon', { action: 'state', row: props.row })"
							></v-switch>
							<span>{{ stateName(props.row) }}</span>
						</v-tooltip>
						<app-tooltip-button
							icon="card_giftcard"
							text="Premio"
							@click-icon="$emit('click-icon', { action: 'presents', row: props.row })"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/edit.svg`"
							text="Editar"
							@click-icon="$emit('click-icon', { action: 'edit', row: props.row })"
						/>
						<!-- <app-tooltip-button
							:img="`${$imageUrl}/delete-button.svg`"
							text="Eliminar"
							color="info"
							@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
						/> -->
					</v-layout>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>

	import axios from 'axios';
	import helper from '@/shared/helper';
	import bus from '@/bus/app-bus';
	import { MAIN_LOADER_EVENT } from '@/modules/shared/components/ui/p-main-loader.constants';

	const { generateBlob, showDownloadDialog } = helper;
	
	function stateName({ status }) {
		return status === 1 ? 'Desactivar' : 'Activar';
	}
	function rowIsSelected(value) {
		this.$emit('row-is-selected', value);
	}

	function selectedAll(value) {
		this.$emit('selected-all', value);
	}

	function setGender(value) {
		return value === 1 ? 'Masculino' : 'Femenino';
	}

	function loadExcel() {
		this.$refs.loadFile.click();
	}

	function loadEmployeesFile(e) {
		const file = e.target.files[0];
		const fileReader = new FileReader();
		fileReader.onload = (event) => {
			this.loadingFile(event.target.result);
		};
		fileReader.readAsDataURL(file);
	}
	async function loadingFile(fileData) {
		try {
			const url = 'employee/import/xlsx';
			const body = {
				base64: fileData.split(',')[1],
			};
			await this.$httpPraktiko.post(url, body).then(() => {
				this.showNotification('Los datos se ha agregado correctamente');
			});
		} catch (error) {
			if (error.data.statusCode === 400) {
				if (error.data.message === 'ONE_OR_MORE_EMPLOYEES_ALREADY_EXIST') {
					this.showGenericError('Uno o más empleados ya existen en los registros');
				} else {
					this.showGenericError();
				}
			} else {
				this.showGenericError();
			}
		} finally {
			this.$emit('load-employees-data');
		}
	}
	async function loadFormat() {
		axios.get('/static/plantilla-empleados.xlsx', {
			responseType: 'blob',
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'plantilla-empleados.xlsx');
			document.body.appendChild(link);
			link.click();
		});
	}

	function changeColor(fieldName) {
		this.columns.forEach((c, index) => {
			if (c.fieldName !== fieldName && c.color) {
				this.$set(this.columns, index, { ...c, color: 'gray' });
			}
		});
	}

	async function downloadEmployees({ type, contentType }) {
		bus.$emit(MAIN_LOADER_EVENT, { show: true, message: 'Procesando...' });
		const body = {};

		if (this.dataSelected.length > 0) {
			const groupIds = this.dataSelected.map(ds => ds.groupId)
				.filter((groupId, index, self) => self.indexOf(groupId) === index);
			const employeeIds = this.dataSelected.map(ds => ds.id)
				.filter((id, index, self) => self.indexOf(id) === index);
			body.groupIds = groupIds;
			body.employeeIds = employeeIds;
		} else if (this.filterArea) {
			body.groupIds = [this.filterArea];
		}
		try {
			const { data: excel } = await this.$httpPraktiko.post('reports/employees/excel', body, { responseType: 'blob' });
			const blob = generateBlob(excel, contentType);
			showDownloadDialog(blob, 'Lista de Empleados', type);
			bus.$emit(MAIN_LOADER_EVENT, { show: false });
		} catch (error) {
			this.showGenericError();
			bus.$emit(MAIN_LOADER_EVENT, { show: false });
		}
	}

	function data() {
		return {
			columns: [
				{
					id: 1,
					name: 'NOMBRE',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'APELLIDO',
					value: 'lastname',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'last_name',
					color: 'gray',
				},
				{
					id: 3,
					name: 'SEXO',
					value: 'gender',
					visible: true,
					checked: true,
				},
				{
					id: 4,
					name: 'EDAD',
					value: 'year',
					visible: true,
					checked: true,
				},
				{
					id: 5,
					name: 'NRO. DOC',
					value: 'numDocument',
					visible: true,
					checked: true,
				},
				{
					id: 6,
					name: 'CORREO',
					value: 'email',
					visible: true,
					checked: true,
				},
				{
					id: 7,
					name: 'ÁREA',
					value: 'area',
					visible: true,
					checked: true,
				},
				{
					id: 8,
					name: 'PUNTOS',
					value: 'points',
					visible: true,
					checked: true,
				},
				{
					id: 9,
					name: 'ACCIONES',
					visible: true,
					checked: true,
					flagVisible: true,
				},
			],
			dataSelected: [],
		};
	}

	export default {
		name: 'employees-list',
		data,
		methods: {
			loadEmployeesFile,
			loadExcel,
			loadingFile,
			rowIsSelected,
			stateName,
			selectedAll,
			setGender,
			loadFormat,
			changeColor,
			downloadEmployees,
		},
		props: {
			rows: {
				default: () => [],
				type: Array,
			},
			checkAll: {
				type: Boolean,
				default: false,
			},
			disabledAssign: {
				type: Boolean,
				default: false,
			},
			currentPage: [Number, String],
			lastPage: [Number, String],
			totalItems: [Number, String],
			totalItemsVisible: [Number, String],
			flagNum: [Number],
			filterArea: {
				type: Number,
				default: null,
			},
			dataSelected: {
				type: Array,
				default: () => [],
			},
		},
		watch: {
			flagNum: {
				handler(newVal, oldVal) {
					if (newVal !== oldVal) {
						this.columns.forEach((c, index) => {
							this.$set(this.columns, index, { ...c, color: 'gray' });
						});
					}
				},
			},
		},
	};
</script>
<style scoped>
.excelButton{
	width: 5px;
	height: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/employees-list.vue